import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, share } from 'rxjs/operators';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ApiResponse } from '@shared/models/api-response.model';
import { MemberBalance } from '@shared/models/member-balance.model';

@Injectable({
  providedIn: 'root'
})
export class WalletHttpService {

  memberBalance: BehaviorSubject<MemberBalance>;

  constructor(private http: HttpClient) { }

  getAllBalance(publishBalance = true): Observable<MemberBalance> {
    if (window.location.pathname == '/gamelaunch') return null;
    return this.http.get<ApiResponse>(`/wallet/allbalance`).pipe(
      map(res => {
        if (publishBalance) {
          this.pushData(res.data);
        }
        return res.data
      }),
    );
  }
  
  getMemberBalance(): Observable<MemberBalance> {
    return this.http.get<ApiResponse>(`/wallet/balance?game_provider_id=0`).pipe(
      map(res => {
        this.pushData(res.data);
        return res.data
      }),
      // share()
    );
  }
  
  // old target-amount
  // getAmountNew(): Observable<MemberBalance> {
  //   if (window.location.pathname == '/gamelaunch') return null;
  //   return this.http.get<ApiResponse>(`/withdraw/target-amount-new`).pipe(
  //     map(res => res.data)
  //   );
  // }

  // new target-amount
  getAmount(): Observable<MemberBalance> {
    if (window.location.pathname == '/gamelaunch') return null;
    return this.http.get<ApiResponse>(`/withdraw/target-amount/v2`).pipe(
      map(res => res.data)
    );
  }

  restoreWallet(): Observable<MemberBalance> {
    return this.http.get<ApiResponse>(`/wallet/restore`).pipe(
      map(res => res.data)
    );
  }

  private pushData(balance: MemberBalance) {
    if (this.memberBalance === undefined) {
      this.memberBalance = new BehaviorSubject<MemberBalance>(balance);
    } else {
      this.memberBalance.next(balance);
    }
  }

}
